<template>
  <main>
    <svg
      width="122"
      height="364"
      viewBox="0 0 122 364"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M78.0043 23.3985C78.0043 25.2745 77.9338 27.0721 77.8102 28.7781C78.1331 28.7262 78.4644 28.6992 78.8019 28.6992C82.2261 28.6992 85.0019 31.4751 85.0019 34.8992C85.0019 38.3234 82.2261 41.0992 78.8019 41.0992C77.7794 41.0992 76.8146 40.8517 75.9644 40.4133C74.8676 44.1409 72.2392 46.7985 68.6043 48.9985L67.9043 49.3985C67.7595 49.4833 67.6131 49.5653 67.4653 49.6443L68.5898 66.7656L83.3047 70.7988C73.8047 79.6992 50.1055 87 38.0039 71.5L37.0039 71.0996L53.5273 66.7676L54.4574 49.6281L54.4043 49.5985C50.3926 47.4016 47.5669 44.566 46.4502 40.5688C45.7309 40.8877 44.9385 41.075 44.1038 41.0996C40.7038 41.1996 37.9038 38.4996 37.8038 35.0996C37.7038 31.6996 40.4038 28.8996 43.8038 28.7996C44.1127 28.7905 44.4166 28.8045 44.714 28.8401C44.454 25.7332 44.4043 23.5985 44.4043 23.5985C44.4043 23.5985 43.0043 5.59853 61.1043 5.79853C79.2044 5.99853 78.0043 23.3985 78.0043 23.3985ZM16.8747 184.322L27.4702 135.293L27.5 135.299L35.8 93.9992L20.9 89.1992L14.6753 131.507C14.5382 131.862 14.4435 132.228 14.3984 132.6C11.6984 153.7 9.39844 185.2 9.39844 185.2L9.59403 185.211L7.19964 199.5C6.69964 203 7.49964 206.5 9.49964 209.2L14.6996 216.1C15.4996 217.3 17.1996 217.1 17.8996 215.8C18.2996 215.1 18.2996 214.3 17.8996 213.6L14.5996 207.8C13.3996 205.8 12.8996 203.4 13.1996 201L13.3996 199.5L14.9996 203.4C15.4996 204.5 16.6996 205 17.6996 204.5C18.5996 204.1 19.1996 203 18.8996 201.9L17.2996 195C18.7002 190.48 17.7501 186.568 16.8747 184.322ZM42.8 348.1L44.8 321.4L30.5 315.6L31.3 348.4L42.8 348.1ZM78.4024 348.1L76.4024 321.4L90.7023 315.6L89.9024 348.4L78.4024 348.1ZM113.854 199.5L111.46 185.211L111.655 185.2C111.655 185.2 109.355 153.7 106.655 132.6C106.61 132.228 106.516 131.862 106.379 131.507L100.154 89.1992L85.2539 93.9992L93.5539 135.299L93.5837 135.293L104.179 184.322C103.304 186.568 102.354 190.48 103.754 195L102.154 201.9C101.854 203 102.454 204.1 103.354 204.5C104.354 205 105.554 204.5 106.054 203.4L107.654 199.5L107.854 201C108.154 203.4 107.654 205.8 106.454 207.8L103.154 213.6C102.754 214.3 102.754 215.1 103.154 215.8C103.854 217.1 105.554 217.3 106.354 216.1L111.554 209.2C113.554 206.5 114.354 203 113.854 199.5Z"
        :style="{ fill: avatar.skin_color }"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M28.0039 252.6C27.9023 171.799 31.6016 147.6 31.6016 147.6H52.3008H69.9023H90.6016C90.6016 147.6 94.3008 170.799 94.1992 251.699L96.8008 335.4H71.5L67.6016 252.5L62.3008 178.5H59.9023L53.6016 252.5L50.7031 335.4H25.4023L28.0039 252.6Z"
        :style="{ fill: avatar.pants_color }"
      />
      <path
        d="M89.8031 123.798L88.7031 111.898L90.6031 92.3984"
        stroke="black"
        stroke-width="0.9528"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M31.4031 124.8L32.7031 111.9L31.2031 92.5996"
        stroke="black"
        stroke-width="0.9528"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M40.7148 34.0993C40.7148 34.0993 43.1148 32.8993 45.5148 37.1993"
        stroke="#C47268"
        stroke-width="0.6887"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M82.5125 33.9991C82.5125 33.9991 80.0125 32.8991 77.8125 37.1991"
        stroke="#C47268"
        stroke-width="0.6887"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M60.2656 32.6406L60.2557 35.0489L61.9579 35.0975"
        stroke="#B9635E"
        stroke-width="0.6612"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M48.5103 23.5816L57.7151 22.7808C57.7151 22.7808 56.9194 20.4024 53.1725 20.7773C49.3259 21.1434 48.5103 23.5816 48.5103 23.5816Z"
        fill="black"
      />
      <path
        d="M73.7948 23.6869L64.6385 22.7854C64.6385 22.7854 65.4454 20.4468 69.2309 20.778C72.9081 21.2001 73.7948 23.6869 73.7948 23.6869Z"
        fill="black"
      />
      <path
        d="M55.643 29.2267C55.6729 30.0324 55.0142 30.6774 54.2172 30.6077C53.4202 30.5379 52.7665 29.9788 52.8362 29.1819C52.8063 28.3762 53.465 27.7312 54.262 27.8009C54.9681 27.7623 55.6131 28.421 55.643 29.2267Z"
        fill="#1E0B02"
      />
      <path
        d="M69.4955 29.2334C69.5254 30.0391 68.8667 30.6841 68.0697 30.6144C67.264 30.6443 66.619 29.9856 66.6887 29.1886C66.6588 28.3829 67.3175 27.7379 68.1145 27.8076C68.8118 27.8686 69.4656 28.4277 69.4955 29.2334Z"
        fill="#1E0B02"
      />
      <path
        d="M55.9294 38.586C55.9294 38.586 59.8569 40.7365 66.169 38.5784"
        stroke="black"
        stroke-width="0.6612"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M67.2992 49.6992C67.1902 50.0353 67.0861 50.366 66.977 50.6861C66.5854 51.8224 66.1195 52.916 65.4701 53.9136C64.9893 54.6551 64.4242 55.3059 63.6757 55.754C63.0362 56.1381 62.3521 56.2555 61.6284 56.1754C60.4288 56.0474 59.4226 55.4553 58.5204 54.6391C57.6083 53.8175 56.8697 52.836 56.2253 51.7744C55.8932 51.2196 55.5908 50.6488 55.2785 50.0886C55.2488 50.0353 55.229 49.982 55.1992 49.9233C59.2639 51.8971 63.2841 51.7851 67.2992 49.6992Z"
        fill="black"
      />
      <path
        d="M72.8382 358.507L72.8125 362.707L121.212 363.003L121.238 358.803L72.8382 358.507Z"
        fill="white"
      />
      <path
        d="M77.8008 344.999C77.8008 344.999 85.8008 350.099 90.1008 342.299L121.201 358.799L72.8008 358.499L77.8008 344.999Z"
        :style="{ fill: avatar.shoes_color }"
      />
      <path
        d="M101.702 354.299C101.802 354.199 101.902 354.199 102.002 353.999C103.902 351.499 105.802 350.299 105.802 350.299C106.202 350.099 106.302 349.599 106.002 349.199C105.802 348.799 105.202 348.799 104.902 348.999C104.802 349.099 102.802 350.399 100.702 353.099C100.402 353.399 100.502 353.899 100.902 354.199C101.202 354.399 101.502 354.399 101.702 354.299Z"
        fill="white"
      />
      <path
        d="M97.7994 352.398C97.8994 352.298 97.9994 352.298 98.0994 352.098C99.9994 349.598 101.899 348.398 101.899 348.398C102.299 348.198 102.399 347.698 102.099 347.298C101.899 346.898 101.299 346.898 100.999 347.098C100.899 347.198 98.8994 348.498 96.7994 351.198C96.4994 351.498 96.5994 351.998 96.9994 352.298C97.1994 352.398 97.4994 352.498 97.7994 352.398Z"
        fill="white"
      />
      <path
        d="M93.7994 350.398C93.8994 350.298 93.9994 350.298 94.0994 350.098C95.9994 347.598 97.8994 346.398 97.8994 346.398C98.2994 346.198 98.3994 345.698 98.0994 345.298C97.8994 344.898 97.2994 344.898 96.9994 345.098C96.8994 345.198 94.8994 346.498 92.7994 349.198C92.4994 349.498 92.5994 349.998 92.9994 350.298C93.2994 350.498 93.5994 350.498 93.7994 350.398Z"
        fill="white"
      />
      <path
        d="M48.4001 358.208L48.4258 362.408L0.0257874 362.704L9.26913e-05 358.504L48.4001 358.208Z"
        fill="white"
      />
      <path
        d="M43.4375 344.7C43.4375 344.7 35.4375 349.8 31.1375 342L0.0375061 358.5L48.4375 358.2L43.4375 344.7Z"
        :style="{ fill: avatar.shoes_color }"
      />
      <path
        d="M19.5365 354C19.4365 353.9 19.3365 353.9 19.2365 353.7C17.3365 351.2 15.4365 350 15.4365 350C15.0365 349.8 14.9365 349.3 15.2365 348.9C15.4365 348.5 16.0365 348.5 16.3365 348.7C16.4365 348.8 18.4365 350.1 20.5365 352.8C20.8365 353.1 20.7365 353.6 20.3365 353.9C20.0365 354.1 19.7365 354.1 19.5365 354Z"
        fill="white"
      />
      <path
        d="M23.4388 352.099C23.3388 351.999 23.2389 351.999 23.1389 351.799C21.2389 349.299 19.3388 348.099 19.3388 348.099C18.9388 347.899 18.8389 347.399 19.1389 346.999C19.3389 346.599 19.9389 346.599 20.2389 346.799C20.3389 346.899 22.3388 348.199 24.4388 350.899C24.7388 351.199 24.6388 351.699 24.2388 351.999C24.0388 352.099 23.7388 352.199 23.4388 352.099Z"
        fill="white"
      />
      <path
        d="M27.4388 350.099C27.3388 349.999 27.2389 349.999 27.1389 349.799C25.2389 347.299 23.3388 346.099 23.3388 346.099C22.9388 345.899 22.8389 345.399 23.1389 344.999C23.3389 344.599 23.9389 344.599 24.2389 344.799C24.3389 344.899 26.3388 346.199 28.4388 348.899C28.7388 349.199 28.6388 349.699 28.2388 349.999C27.9388 350.199 27.6388 350.199 27.4388 350.099Z"
        fill="white"
      />
      <path
        d="M49.5039 178.5H68.9039"
        stroke="#494949"
        stroke-width="0.9528"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M90.1283 124.71L110.953 113.1C110.953 113.1 104.553 99.0996 99.3531 85.6996C95.3246 75.3183 88.3551 72.2594 85.4194 71.4081C81.9253 70.1535 78.2016 69.7988 78.2016 69.7988L60.7016 71.5988L43.2016 69.7988C43.2016 69.7988 40.0377 70.1001 36.8062 71.1299C35.3785 71.3783 26.4753 73.3981 21.7016 85.6996C16.5016 99.0996 10.1016 113.1 10.1016 113.1L31.2392 124.884L25.1016 168.399L96.7016 168.799L90.1283 124.71Z"
        :style="{ fill: avatar.shirt_color }"
      />
      <path
        d="M37.0039 71.0992L57.6039 65.6992H64.7039L83.3039 70.7992C73.8039 79.6992 50.1039 86.9992 38.0039 71.4992L37.0039 71.0992Z"
        :style="{ fill: avatar.skin_color }"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M91.3008 52.6016C91.1016 50.9023 91.2031 49.2012 91.6016 47.6016C93.7031 39.502 91.3008 32.6016 87.0039 27.4023C83.1016 22.7012 82.2031 15.8027 82.2031 15.8027C79.4023 6.50195 69.8008 0.00195312 61.0039 0.00195312C52.2031 0.00195312 42.6016 6.10156 39.8008 15.502C39.8008 15.502 38.5039 22.9023 34.9023 27.502C30.8008 32.8027 28.2031 39.6016 30.3008 47.7012C30.4727 48.3789 30.5898 49.0742 30.6523 49.7793C30.7344 50.7402 30.7148 51.7207 30.6016 52.7012C30.5039 53.9023 30.1016 55.2012 29.4023 56.1016H54.0703L54.4023 49.5977C50.3906 47.4023 47.5664 44.5684 46.4492 40.5703C45.7266 40.8906 44.9375 41.0742 44.1016 41.0996C40.7031 41.1992 37.9023 38.5 37.8047 35.0996C37.7031 31.6992 40.4023 28.9004 43.8047 28.7988C44.1094 28.7891 44.4219 28.8105 44.7148 28.8457C44.4531 25.7344 44.4023 23.5977 44.4023 23.5977C44.4023 23.5977 44.2383 21.5078 44.7422 18.7598C48.5234 17.6582 56.3594 14.6914 60.3047 8.25C65.1445 16.1523 75.8281 18.8301 77.7109 19.2461C78.125 21.6445 78.0039 23.3984 78.0039 23.3984C78.0039 25.2754 77.9336 27.0762 77.8086 28.7832C78.1328 28.7305 78.4609 28.6992 78.8008 28.6992C80.8711 28.6992 82.7031 29.7129 83.8281 31.2715C84.5664 32.291 85 33.5449 85 34.8984C85 38.3242 82.2266 41.0996 78.8008 41.0996C78.3906 41.0996 77.9922 41.0605 77.6094 40.9844C77.4102 40.9453 77.2148 40.8965 77.0234 40.8379C76.6562 40.7266 76.3047 40.582 75.9688 40.4082C74.8711 44.1387 72.2383 46.7988 68.6055 48.998L67.9023 49.3984L67.4648 49.6426L67.8867 56.1016H92.3008C91.8008 55.1016 91.5039 53.8027 91.3008 52.6016Z"
        :style="{ fill: avatar.hair_color }"
      />
    </svg>
  </main>
</template>
<script>
export default {
  props: {
    avatar: Object,
  },
};
</script>